export const GET_INTERESTING_CUSTOMER_LIST = 'GET_INTERESTING_CUSTOMER_LIST';
export const UPDATE_SEARCH_PARAMS_INFO = 'UPDATE_SEARCH_PARAMS_INFO';
export const UPDATE_SEARCH_PARAMS_CLEAR = 'UPDATE_SEARCH_PARAMS_CLEAR';
export const UPDATE_INTEREST_PARAM = 'UPDATE_INTEREST_PARAM';
export const UPDATE_INTEREST_PARAM_CLEAR = 'UPDATE_INTEREST_PARAM_CLEAR';

export const interestingCustomerPagingList = payload => {    
    return { type: GET_INTERESTING_CUSTOMER_LIST, payload };
};

export const updateSearchParams = payload => {
    return { type: UPDATE_SEARCH_PARAMS_INFO, payload };
};

export const updateSearchParamsClear = payload => { 
    return { type: UPDATE_SEARCH_PARAMS_CLEAR, payload };
};

export const updateInterestParam = payload => {
    return { type: UPDATE_INTEREST_PARAM, payload };
};

export const updateInterestParamClear = payload => {
    return { type: UPDATE_INTEREST_PARAM_CLEAR, payload };
};